export const AGE_RANGES = [
  '18-24',
  '25-34',
  '35-44',
  '45-54',
  '55-64',
  '65-74',
  '75+'
];

export const ACTIVITY_LEVELS = [
  { value: 'sedentary', label: 'Sedentary', description: 'Little to no exercise' },
  { value: 'light', label: 'Lightly Active', description: 'Light exercise 1-3 days/week' },
  { value: 'moderate', label: 'Moderately Active', description: 'Moderate exercise 3-5 days/week' },
  { value: 'active', label: 'Active', description: 'Hard exercise 6-7 days/week' },
  { value: 'very-active', label: 'Very Active', description: 'Very hard exercise daily' }
];

export const CHRONIC_CONDITIONS = [
  'Hypertension',
  'Type 2 Diabetes',
  'Type 1 Diabetes',
  'Heart Disease',
  'Asthma',
  'COPD',
  'Arthritis',
  'Depression',
  'Anxiety',
  'Thyroid Disorder',
  'High Cholesterol',
  'Other'
];

export const STRESS_MANAGEMENT_PRACTICES = [
  'Meditation',
  'Yoga',
  'Deep Breathing',
  'Exercise',
  'Journaling',
  'Therapy/Counseling',
  'Time in Nature',
  'Hobbies',
  'Social Connection',
  'Adequate Sleep'
];

export const SCORE_RANGES = [
  { min: 0, max: 399, label: 'Needs Attention', color: 'bg-red-500', description: 'Multiple areas with high potential for improvement' },
  { min: 400, max: 599, label: 'Fair', color: 'bg-orange-500', description: 'Room for improvement in several areas' },
  { min: 600, max: 749, label: 'Good', color: 'bg-yellow-500', description: 'Solid foundation with opportunities to optimize' },
  { min: 750, max: 899, label: 'Very Good', color: 'bg-green-500', description: 'Strong health profile with minor improvements possible' },
  { min: 900, max: 1000, label: 'Excellent', color: 'bg-emerald-500', description: 'Outstanding health profile' }
];

export const getScoreRange = (score: number) => {
  return SCORE_RANGES.find(range => score >= range.min && score <= range.max) || SCORE_RANGES[0];
};

export const CATEGORY_INFO = {
  cardiovascular: {
    name: 'Cardiovascular',
    icon: 'ri-heart-pulse-line',
    description: 'Heart health, circulation, and aerobic fitness'
  },
  metabolic: {
    name: 'Metabolic',
    icon: 'ri-fire-line',
    description: 'Weight, nutrition, blood sugar, and metabolism'
  },
  lifestyle: {
    name: 'Lifestyle',
    icon: 'ri-walk-line',
    description: 'Daily habits, movement, and health behaviors'
  },
  recovery: {
    name: 'Recovery',
    icon: 'ri-moon-line',
    description: 'Sleep quality, rest, and recuperation'
  },
  mental: {
    name: 'Mental Wellbeing',
    icon: 'ri-mental-health-line',
    description: 'Stress management, balance, and emotional health'
  }
};
